// extracted by mini-css-extract-plugin
module.exports = {"powerStationStats__container":"PowerStationStats_powerStationStats__container__5rJoe"};